module.exports = __webpack_public_path__ + "static/media/medissahImg.9b181ca7.png";